// extracted by mini-css-extract-plugin
export var heading = "styles-module__heading___KiJAw";
export var mobile = "styles-module__mobile___yUlyc";
export var proWelcome = "styles-module__proWelcome___A2MGd";
export var topImage = "styles-module__topImage___kZWmV";
export var welcome = "styles-module__welcome___cAeNi";
export var welcomeProBadge = "styles-module__welcomeProBadge___cRNSz";
export var welcomeText = "styles-module__welcomeText___c8ru3";